import { Component, input, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormGroupAtpHtml } from '../models/HtmlModels';
import { FormGroupContextBase, FormGroupContextConfig } from '../models/FormModels';

@Component({
  selector: 'app-voucher-atp-form-header',
  templateUrl: './voucher-atp-form-header.component.html',
  styleUrls: ['./voucher-atp-form-header.component.scss'],
  standalone: false
})
export class VoucherAtpFormHeaderComponent {
  groupHtml = input.required<FormGroupAtpHtml>();
  formGroupContextBase = input<FormGroup<FormGroupContextConfig> | FormGroup<FormGroupContextBase>>();
  canModify = input.required<boolean>();

  remove = output();
}
